<template>
  <div class="scanned-items-list">
    <div v-if="items.length" class="scanned-items-list__header">
      <h6 class="mb-0">Escaneados en esta sesión ({{ items.length }})</h6>
      <b-button
        size="sm"
        variant="outline-light"
        @click="onClear"
      >
        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">delete_sweep</span>
        Limpiar
      </b-button>
    </div>
    <div v-if="items.length" class="scanned-items-list__table-wrapper">
      <b-table
        :items="items"
        :fields="fields"
        responsive
        striped
        hover
        small
        class="scanned-items-list__table"
      >
        <!-- Slots dinámicos: el padre pasa #cell(KEY) y los reenviamos al b-table -->
        <template
          v-for="field in fields"
          v-slot:[`cell(${field.key})`]="slotProps"
        >
          <slot
            :name="`cell(${field.key})`"
            v-bind="slotProps"
          >
            <!-- Fallback: si el padre no define slot, muestra el valor crudo -->
            {{ slotProps.value }}
          </slot>
        </template>
      </b-table>
    </div>
    <div v-else class="scanned-items-list__empty">
      <span class="material-icons">inbox</span>
      <p class="mb-0">Aún no hay escaneos en esta sesión</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScannedItemsList',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    fields: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    onClear() {
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
.scanned-items-list {
  border-radius: 8px;
  padding: 0.75rem;
}

.scanned-items-list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  padding: 0 0.25rem;
}

.scanned-items-list__header h6 {
  font-weight: 600;
  font-size: 0.85rem;
}

.scanned-items-list__table-wrapper {
  max-height: 280px;
  overflow-y: auto;
}

.scanned-items-list__table {
  margin-bottom: 0 !important;
}

.scanned-items-list__table >>> th {
  border-color: rgba(255, 255, 255, 0.05) !important;
  font-size: 0.8rem;
  padding: 0.5rem !important;
}

.scanned-items-list__table >>> td {
  border-color: rgba(255, 255, 255, 0.05) !important;
  font-size: 0.85rem;
  padding: 0.5rem !important;
  vertical-align: middle;
}

.scanned-items-list__empty {
  text-align: center;
  padding: 1.5rem 1rem;
}

.scanned-items-list__empty .material-icons {
  font-size: 32px;
  display: block;
  margin-bottom: 0.5rem;
  opacity: 0.5;
}
</style>